module.exports = __webpack_public_path__ + "static/media/handerR.eea43384.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/handerR.png
// module id = 1758
// module chunks = 0 1